import $ from 'jquery';
import throttle from 'lodash.throttle';

// Это можно было бы сделать и виде плагина, но в проекте это нужно только для этих кнопок
const init = () => {
    $('.modal__scroll_content').on(
        'scroll',
        throttle(function() {
            const stickyBtn = this.querySelector('.js_sticky_btn');

            if (stickyBtn && window.innerWidth > 991) {
                let position = stickyBtn.getBoundingClientRect();

                if (this.scrollTop >= stickyBtn.dataset.stickyOffset || 0) {
                    $(stickyBtn).css({
                        position: 'fixed',
                        top: `${stickyBtn.dataset.stickyOffset}px`,
                        right: 'auto',
                        left: `${position.left}px`
                    });
                } else {
                    $(stickyBtn).removeAttr('style');
                }
            }
        }, 100)
    );
};

export default init();
